<template>
  <div>
    <p v-if="loading">Loading Company...</p>
    <LinkEntity
      v-if="company"
      :payload="company"
      :additional_data="{ resource_type: 'Company' }" />
  </div>
</template>
<script>
import LinkEntity from '@/components/LinkEntity'
export default {
  name: 'outsource-company-link-entity',
  components: {
    LinkEntity
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      company: null,
      position: null,
      loading: false
    }
  },
  mounted () {
    this.fetchCompany()
  },
  methods: {
    async fetchCompany () {
      this.loading = true
      this.position = await this.$network_utils.getPosition({ id: this.payload.env_position_id })
      this.company = await this.$network_utils.getCompany({ id: this.position.company.resource_id })
      this.loading = false
    }
  }

}
</script>
